<div class="relative fx-card fx-fill">
	<router-outlet></router-outlet>
</div>
